var React = require('react');

function FsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.5833 13.5974L25.5 13.5833C24.7208 13.5833 24.0833 14.2208 24.0833 14.9999V27.7499C24.0833 28.5291 24.7208 29.1666 25.5 29.1666H32.5833C33.3625 29.1666 34 28.5291 34 27.7499V14.9999C34 14.2208 33.3625 13.5974 32.5833 13.5974ZM32.5833 26.3333H25.5V16.4166H32.5833V26.3333ZM28.3333 0.833252H2.83333C1.26083 0.833252 0 2.09409 0 3.66659V20.6666C0 22.2249 1.26083 23.4999 2.83333 23.4999H12.75V26.3333H9.91667V29.1666H21.25V26.3333H18.4167V23.4999H21.25V20.6666H2.83333V3.66659H28.3333V10.7499H31.1667V3.66659C31.1667 2.09409 29.8917 0.833252 28.3333 0.833252ZM16.9575 10.7499L15.5833 6.49992L14.2092 10.7499H9.91667L13.4158 13.2433L12.0842 17.3658L15.5833 14.8158L19.0825 17.3658L17.7508 13.2433L21.25 10.7499H16.9575Z","fill":"#252525"}));
}

FsInline.defaultProps = {"width":"34","height":"30","viewBox":"0 0 34 30","fill":"none"};

module.exports = FsInline;

FsInline.default = FsInline;
